'use client'

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const data = [
  { month: 'Jan', executions: 2400, cost: 1200 },
  { month: 'Feb', executions: 3200, cost: 1600 },
  { month: 'Mar', executions: 2800, cost: 1400 },
  { month: 'Apr', executions: 4100, cost: 2050 },
  { month: 'May', executions: 3800, cost: 1900 },
  { month: 'Jun', executions: 4500, cost: 2250 },
]

export default function UsageChart() {
  return (
    <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Usage & Costs</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="executions" stroke="#3b82f6" strokeWidth={2} />
          <Line type="monotone" dataKey="cost" stroke="#10b981" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
